<template>
  <b-card>
    <b-card-title>
      <h5 class="text-left">
        Dispatch Messages for cycle {{ cycleNumber }}
      </h5>
    </b-card-title>

    <b-table
      :fields="tableColumns"
      :items="dispatchMessages"
      show-empty
      empty-text="No matching records found"
      class="text-center"
    >
      <template #cell(driver_details)="row">
        <b-form-checkbox
          v-model="row.detailsShowing"
          @change="showDriverDetails(row)"
        >
          <span>{{ row.detailsShowing ? 'Hide' : 'Show' }} driver details</span>
        </b-form-checkbox>
      </template>
      <template #row-details="row">
        <b-card>
          <b-card-title>
            <h5 class="text-left">
              Driver Details
            </h5>
          </b-card-title>
          <b-overlay
            variant="white"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
            :show="row.item.loading"
          >
            <b-table
              :fields="driverTableColumns"
              :items="row.item.driverDetails"
              show-empty
              empty-text="Not Found"
            >
              <template #cell(driver)="data">
                {{ data.item.firstName + ' ' + data.item.lastName }}
              </template>
            </b-table>
          </b-overlay>
        </b-card>
      </template>
    </b-table>

  </b-card>
</template>

<script>
/* eslint-disable no-param-reassign */

import {
  BTable, BCard, BCardTitle, BFormCheckbox,
  BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BTable,
    BCard,
    BCardTitle,
    BFormCheckbox,
    BOverlay,
  },

  props: {
    dispatches: {
      type: Array,
      default: () => [],
    },
    cycleNumber: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const tableColumns = [
      {
        key: 'driver_details',
        label: '',
      },
      {
        key: 'user_id',
        label: 'driver',
      },
      {
        key: 'distance',
        label: 'distance to user',
      },
      {
        key: 'state',
        label: 'state',
      },
    ]
    const dispatchMessages = ref([])
    dispatchMessages.value = props.dispatches?.map(dispatch => {
      const splittedDistanceToVersionSlice = dispatch.metadata.substring(
        dispatch.metadata.indexOf('\'distance'),
        dispatch.metadata.indexOf('\'version') + 1,
      ).replaceAll(' ', '')

      const distanceAsStr = splittedDistanceToVersionSlice.substring(
        splittedDistanceToVersionSlice.indexOf(':') + 1,
        splittedDistanceToVersionSlice.lastIndexOf(','),
      )
      const distanceAsNum = Number(distanceAsStr).toFixed(2)
      return {
        user_id: dispatch.user,
        distance: distanceAsNum,
        state: dispatch.state.replaceAll('_', ' ').toLowerCase(),
        loading: false,
        loaded: false,
      }
    })
    const driverTableColumns = [
      { key: 'driver', label: 'driver' },
      { key: 'phoneNumber', label: 'phone number' },
      { key: 'nationalId', label: 'national id' },
      { key: 'status', label: 'status' },
      { key: 'acceptanceRatio', label: 'acceptance ratio', formatter: val => `${val} %` }]

    const showDriverDetails = async row => {
      row.toggleDetails()
      if (row.item.loaded) return
      try {
        row.item.loading = true
        const response = (await ctx.root.$store.dispatch('drivers/fetchDriverDetails', row.item.user_id)).data.data
        row.item.loaded = true
        row.item.driverDetails = [response]
      } finally {
        row.item.loading = false
      }
    }
    return {
      tableColumns,
      dispatchMessages,
      showDriverDetails,
      driverTableColumns,
    }
  },

}
</script>

<style>

</style>
